import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            The Kinos Land Services mission is to accelerate our clients’ success through superior market knowledge, industry-leading technology and a global real estate perspective.
          </h3>
          <p>
            Kinos Land Services professionals specialize in land entitlement and disposition, offering clients extensive knowledge of local market conditions, competitive land parcels and regulatory issues,to assist land owners in maximizing their real estate values. Land owner, developer and investor representation services include market analysis and feasibility studies, strategic site selection, financial analysis, demographic and mapping services and property acquisitions and dispositions.

            <br /><br />
              We leverage experts in our Capital Markets, Valuation and Advisory and Industrial, Retail and Office brokerage specialties to accelerate our clients’ success through superior market knowledge, industry-leading technology,and a global real estate perspective.

            <br /><br />
            Kinos Land Services maintains a database of thousands of global land investors, high net worth individuals, foreign investors and family offices to effectively and efficiently market properties. Our professionals assemble teams of trained specialists in various service lines to market parcels directly to investors and end users.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured= {featured} url="urban_land" />
          <SectionRecents recents= {recents} url="urban_land" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
